// extracted by mini-css-extract-plugin
module.exports = {"containerStats":"SectionStats_containerStats__gvcm5","statsNumber":"SectionStats_statsNumber__OHeSI","statsLabel":"SectionStats_statsLabel__20OzW"};